// extracted by mini-css-extract-plugin
export default {"mainContainer":"ReturnedStampsRecords_mainContainer__c4VLg","buttonSubcontainer":"ReturnedStampsRecords_buttonSubcontainer__FR3Jc"};